import React, { Component, PropTypes } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';

import './tenantsForm.scss';

import tenantsStore from 'storeState/tenants';
import authStore from 'storeState/auth';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import _ from 'lodash';

import FormField from 'views/formField/FormField';
import FormHeading from 'views/formHeading/FormHeading';
import FormButtons from 'views/formButtons/FormButtons';
import Button from 'views/button/Button';
import URLService from "../../../service/URLService";

const defaultState = {
    inputName: "",
    stringId: ""
};

export class TenantsForm extends Component {

    static contextTypes = {
        intl: PropTypes.object,
        tenant_id: PropTypes.string
    }

    handleNameChange = (ev) => {
        this.setState({
            inputName: ev.target.value
        });
    }

    handleStringIdChange = (ev) => {
        this.setState({
            stringId: ev.target.value
        });
    }

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.tenants != this.props.tenants || nextProps.tenant_id != this.props.tenant_id) {
            this.tenant = null;
            this.setState({
                ...defaultState
            })

            if(nextProps.tenant_id) {
                let tenant = _.find(nextProps.tenants,(t) => {
                    return t.id==nextProps.tenant_id;
                });
                if(tenant) {
                    this.tenant = tenant;
                    this.setState({
                        inputName: this.tenant.name,
                        stringId: this.tenant.string_id,
                    });
                }
            }
        }

    }

    handleSaveButtonClick = () => {
        if(this.tenant) {
            this.props.actions.tenantUpdateRequest({
                tenant_id: this.tenant.id,
                tenant: {
                    name: this.state.inputName,
                    string_id: this.state.stringId,
                }
            });
        } else {
            this.props.actions.tenantCreateRequest({
                tenant: {
                    name: this.state.inputName,
                    string_id: this.state.stringId,
                }
            });
        }
    }

    handleDeleteButtonClick = () => {
        if(this.tenant) {
            this.props.actions.tenantDeleteRequest({
                tenant_id: this.tenant.id
            });
        }
    }

    handleChooseButtonClick = () => {
        if(this.tenant) {
            this.props.actions.setCurrentTenantId({tenant_id: this.tenant.id})
        }
    }

    render() {
        return (
            <div className={`tenants-form`}>
                <FormHeading>
                    <If condition={this.tenant}>
                        <span>
                            <FormattedMessage id="tenantsForm.heading.editing" defaultMessage="Editing" />
                            &nbsp;
                            {this.tenant.name}
                        </span>
                    <Else />
                        <span>
                            <FormattedMessage id="tenantsForm.heading.new" defaultMessage="New tenant" />
                        </span>
                    </If>
                </FormHeading>
                <FormField label={<FormattedMessage id="tenantsForm.name.label" defaultMessage="Name" />}>
                    <input
                        type="text"
                        value={this.state.inputName}
                        onChange={this.handleNameChange}
                    />
                </FormField>
                <FormField label={<FormattedMessage id="tenantsForm.tenant.label" defaultMessage="Tenant" />}>
                    <input
                      type="text"
                      value={this.state.stringId}
                      onChange={this.handleStringIdChange}
                    />
                </FormField>

                <FormButtons>
                    <If condition={this.tenant}>
                        <Button onClick={this.handleChooseButtonClick}>
                            <FormattedMessage id="tenantsForm.choose" defaultMessage="Choose" />
                        </Button>

                        <Button onClick={this.handleDeleteButtonClick}>
                            <FormattedMessage id="tenantsForm.delete" defaultMessage="Delete" />
                        </Button>
                    </If>

                    <Button onClick={this.handleSaveButtonClick}>
                        <If condition={this.tenant}>
                            <FormattedMessage id="tenantsForm.save.update" defaultMessage="Save" />
                        <Else />
                            <FormattedMessage id="tenantsForm.save.new" defaultMessage="Create" />
                        </If>
                    </Button>
                </FormButtons>
            </div>
        );
    }
}


export default connect((state, props) => {
  return {
    tenants: tenantsStore.selectors.tenantsList(state)
  }
},(dispatch, props) => {
  return {
    actions: bindActionCreators(Object.assign({}, authStore.actions, tenantsStore.actions), dispatch)
  }
})(TenantsForm)



// WEBPACK FOOTER //
// ./src/components/views/tenantsForm/TenantsForm.js